import script from "./Question.vue?vue&type=script&lang=ts&name=Question&setup=true"
export * from "./Question.vue?vue&type=script&lang=ts&name=Question&setup=true"

import "./Question.vue?vue&type=style&index=0&id=9ec4fa0e&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ec4fa0e"]])

export default __exports__